import { useSelector, useStore, useDispatch } from "react-redux";
import PlayerFormat from "../../util/player-format";
import { setView as setViewAction } from "./actions";

const usePlayersFootballContext = ({ team }) => {
	const dispatch = useDispatch();
	const store = useStore();
	const useParticipatingPlayers = () => {
		const { teams } = store.getState().teamContext;
		const { participants } = teams[team?.id] || {};

		return useSelector((state) =>
			participants
				? state.players.players
						.filter(
							(p) =>
								p.teamId === team.id &&
								participants.some((participantId) => participantId === p.id)
						)
						.sort((a, b) => PlayerFormat.compareUniforms(a.uniform, b.uniform))
				: []
		);
	};

	const useActivePlayers = (excludedUniforms = []) =>
		useSelector((state) =>
			state.players.players
				.filter(
					(p) =>
						p.teamId === team.id &&
						(p.active ||
							[PlayerFormat.TeamUniform, PlayerFormat.NotSpecifiedUniform].some(
								(u) => u === p.uniform
							)) &&
						!excludedUniforms.some((u) => u === p.uniform)
				)
				.sort((a, b) => PlayerFormat.compareUniforms(a.uniform, b.uniform))
		);

	const useView = () => {
		return useSelector((state) => state.players.view);
	};

	const state = {
		participatingPlayers: useParticipatingPlayers,
		activePlayers: useActivePlayers,
		view: useView
	};

	const setView = (value) => {
		setViewAction(value, dispatch);
	};

	return {
		state,
		setView
	};
};

export { usePlayersFootballContext };
